import React, {Fragment} from 'react';
import AceEditor from 'react-ace';
import isEqual from "lodash-es/isEqual";
import PropTypes from 'prop-types';

import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-monokai";

const defaultTheme = "monokai";

export default class CodeEditor extends React.Component {

    static propTypes = {
        label: PropTypes.any,
        mode: PropTypes.string,
        theme: PropTypes.string,
        value: PropTypes.any,
        name: PropTypes.string,
        disabled: PropTypes.oneOf([true, false, "true", "false", "disabled"]),
        saveChanges: PropTypes.func,
    }

    onChange = (value, event) => {
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, value, event);
        }
    }

    render() {
        return <Fragment>
            <label htmlFor={this.props.name} className="control-label">{this.props.label}</label>
            <AceEditor
                width="100%"
                height="100%"
                mode={this.props.mode}
                theme={this.props.theme || defaultTheme}
                {...this.props}
                onBlur={(event, editor) => this.onChange(editor.getValue(), event)}
                value={this.props.value}
                className={this.props.className}
                name={this.props.name}
                readOnly={this.props.disabled}
                editorProps={{$blockScrolling: true}}
            />
        </Fragment>;
    }
}